import React, { FC } from 'react'
import './IconPlus2.less'

const IconPlus2: FC = () => {
  return (
    <div className={'Icon IconPlus2'} role="img" aria-label="Icon Plus">
      +
    </div>
  )
}

export default IconPlus2
